import { call, put, takeEvery } from "redux-saga/effects";
import { UpdateAccountInfoAction, UpdateSignInRequestState } from "./action";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../request";
import { Post } from "../../api";
import { TransformAuthResponse } from "./transformer";

export function* authenticationSaga() {
  yield takeEvery("authentication-update-sign-in", signIn);
}

function* signIn(action: any) {
  try {
    yield put(UpdateSignInRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/manage/signin", {
      mail: action.mail,
      password: action.password,
    });

    if (!response["jwtToken"]) {
      yield put(UpdateSignInRequestState(RequestFailedUpdate));
      return;
    }

    const authResponse = TransformAuthResponse(response);

    yield put(UpdateAccountInfoAction(authResponse));

    localStorage.setItem("jwtToken", response.jwtToken);
    localStorage.setItem("b", authResponse.showBiddingType ? "1" : "0");
    localStorage.setItem("mail", action.mail);
    localStorage.setItem("a", authResponse.isAdmin ? "1" : "0");

    yield put(UpdateSignInRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    console.warn(e);
    yield put(UpdateSignInRequestState(RequestFailedUpdate));
  }
}
